/**
* Custom Select
*/
class customSelect extends HTMLElement{
  constructor() {
    super();
    this.selectContainer = this.querySelector('.custom-dropdown');
    this.select = this.querySelector('ul');
    this.initOption = this.querySelector('.default');
    this.options = this.select.querySelectorAll('li');

    this.options.forEach(option => option.addEventListener('click', this.toggleOptions.bind(this)));
    this.initOption.addEventListener('click', this.manageVisibility.bind(this));

    this.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    document.body.addEventListener('click', ()=> {
      this.selectContainer.querySelector('[data-type="content"]').style.height = '0';
      Utility.toggleElement(this.selectContainer, 'close')
    });
  }

  /**
   * Toggle custom select option
   * @param event 
   */
  toggleOptions(event){
    let _this = event.currentTarget;
    this.selectContainer.querySelector('[data-type="content"]').style.height = '0';
    Utility.toggleElement(this.selectContainer, 'close');
    setTimeout(() => {
      this.initOption.querySelector('.option_txt').textContent = _this.querySelector('.option_txt').textContent;
      if(this.selectContainer.querySelector('[data-selecttab]')){
        let input_val = this.selectContainer.querySelector('[data-selecttab] input:checked').closest('li').dataset.value;
        document.querySelector(`.tabs [data-toggle="tab"][data-tabcontent="${input_val}"]`).click();
      }
    }, 500);
    
  }

  /**
   * Hide/Show of custom select option
   * @param _event 
   */
    manageVisibility(_event){
      let isOpen = this.selectContainer.classList.contains('open');
      if(isOpen){
        this.selectContainer.querySelector('[data-type="content"]').style.height = '0';
        Utility.toggleElement(this.selectContainer, 'close');
      } else {
        let newscrollHeight = this.selectContainer.querySelector('[data-type="content"]').scrollHeight;
        this.selectContainer.querySelector('[data-type="content"]').style.height = newscrollHeight + 'px';
        Utility.toggleElement(this.selectContainer, 'open')
      }
    }
}
customElements.define('custom-select', customSelect);
class archiveCustomSelect extends customSelect {
  constructor(){
    super()
    this.options = this.select.querySelectorAll('li');
    //console.log(this.options);
    this.options.forEach(option => option.addEventListener('click', this.archivetoggleOptions.bind(this)));
  }
  toggleOptions(event){
    let _this = event.currentTarget;
    this.selectContainer.querySelector('[data-type="content"]').style.height = '0';
    Utility.toggleElement(this.selectContainer, 'close');
    setTimeout(() => {
      this.initOption.querySelector('.option_txt').textContent = _this.querySelector('.option_txt').title;
      if(this.selectContainer.querySelector('[data-selecttab]')){
        let input_val = this.selectContainer.querySelector('[data-selecttab] input:checked').closest('li').dataset.value;
        document.querySelector(`.tabs [data-toggle="tab"][data-tabcontent="${input_val}"]`).click();
      }
    }, 500);
    
  }
  archivetoggleOptions(event){
    event.preventDefault();
    event.stopPropagation();
    // console.log("event",event);
    let _this = event.currentTarget;
    this.selectContainer.querySelector('[data-type="content"]').style.height = '0';
    Utility.toggleElement(this.selectContainer, 'close');
    let selected_value = _this.querySelector('input');
    selected_value.checked = true;
    let current_url = window.location.href;
    let new_url = current_url.includes('/tagged/')?current_url.split('/tagged/')[0]:current_url;
    if(selected_value.value == ''){
      window.location.href = new_url;
      return;
    }    
    window.location.href = new_url.split('?page')[0] + '/tagged/'+ selected_value.value;   
  }
}
customElements.define('archive-custom-select', archiveCustomSelect);

class CustomSortWebinar extends customSelect {
  constructor(){
    super()
    this.options = this.select.querySelectorAll('li');
    //console.log(this.options);
    this.options.forEach(option => option.addEventListener('click', this.sortItemsBy.bind(this)));
  }
  toggleOptions(event){
    let _this = event.currentTarget;
    this.selectContainer.querySelector('[data-type="content"]').style.height = '0';
    Utility.toggleElement(this.selectContainer, 'close');
    setTimeout(() => {
      this.initOption.querySelector('[data-currentvalue]').textContent = _this.querySelector('.option_txt').title;
      if(this.selectContainer.querySelector('[data-selecttab]')){
        let input_val = this.selectContainer.querySelector('[data-selecttab] input:checked').closest('li').dataset.value;
        document.querySelector(`.tabs [data-toggle="tab"][data-tabcontent="${input_val}"]`).click();
      }
    }, 500);
    
  } 
  sortItemsBy(event){
    event.preventDefault();
    event.stopPropagation();
    // console.log("event",event);
    let _this = event.currentTarget;
    this.selectContainer.querySelector('[data-type="content"]').style.height = '0';
    Utility.toggleElement(this.selectContainer, 'close');
    let selected_value = _this.querySelector('input');
    selected_value.checked = true;
    document.dispatchEvent(sortingChanged);
  }
}
customElements.define('custom-sort-webinar', CustomSortWebinar);
class digitalCustomSelect extends archiveCustomSelect {
  constructor(){
    super()
    this.options = this.select.querySelectorAll('li');
    //console.log(this.options);
    this.options.forEach(option => option.addEventListener('click', this.archivetoggleOptions.bind(this)));
  }
  archivetoggleOptions(event){
    event.preventDefault();
    event.stopPropagation();
    // console.log("event",event);
    let _this = event.currentTarget;
    this.selectContainer.querySelector('[data-type="content"]').style.height = '0';
    Utility.toggleElement(this.selectContainer, 'close');
    let selected_value = _this.querySelector('input');
    selected_value.checked = true;
    document.dispatchEvent(sortingChanged);
  }

}
customElements.define('digitalsort-custom-select', digitalCustomSelect);
/**
* Tab HTML
*/
class customTabs extends HTMLElement {
  constructor() {
    super();
    let _this = this;
    _this.querySelector(".tab-slider").style.opacity = '1';
    _this.tabLinks = this.querySelectorAll('.tablink');
    _this.tabContainers = this.querySelectorAll('.tabcontent');

    setTimeout(function () {
      let parent_position = _this.querySelector('.tablink.open').parentElement.getBoundingClientRect();
      let position = _this.querySelector('.tablink.open').getBoundingClientRect();
      let width = _this.querySelector('.tablink.open').offsetWidth;
      _this.querySelector(".tab-slider").style.left = position.left - parent_position.left + "px";
      _this.querySelector(".tab-slider").style.width = width + "px";
    }, 200);
  
    
    this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
  }

  /**
   * Toggle Tabs on link click
   *
   * @param {event} Event instance
   */
  toggleTabs(event){
    event.preventDefault();
    event.stopPropagation();
    const currentTab = event.currentTarget;
    const tabLink = currentTab.querySelector('[data-toggle="tab"]');
    const tabContainer = document.querySelector(tabLink.dataset.tabcontent);

    this.openTab(currentTab, tabContainer)
  }

  /**
   * Open Tab Container
   *
   * @param {Node} currentTab Tab Container Open link
   * @param {Node} tabContainer Tab Container to open
   */
  openTab(currentTab, tabContainer) {
    let _this = this;
    let parent_position = currentTab.parentElement.getBoundingClientRect();
    let position = currentTab.getBoundingClientRect();
    let width = currentTab.offsetWidth;
    _this.querySelector(".tab-slider").style.left = position.left - parent_position.left + "px";
    _this.querySelector(".tab-slider").style.width = width + "px";

    this.tabContainers.forEach(container => {
      container.classList.remove('open');
      setTimeout(() =>{
        container.classList.remove('show');
      }, 100);
      const linkEle = _this.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
      if(linkEle){
        linkEle.setAttribute('aria-expanded', false);
        if(linkEle.closest('.tablink')){ 
          linkEle.closest('.tablink').classList.remove('open');
        }
      }
    });
    currentTab.classList.add('open');
    currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
    tabContainer.classList.add('open');
    setTimeout(() =>{
      tabContainer.classList.add('show');
    }, 100);
    
  }
}
customElements.define("custom-tabs", customTabs);

/**
  * collaspsible Panel
  *
  * @param {element} element - Collapsible panel element
*/
class collapsiblePanel {
  constructor(element) {
    this.element = element;
    this.toggleBtn = this.element.querySelector('.panel_toggle');
    if(this.toggleBtn) this.toggleBtn.addEventListener('click', this.toggleContent.bind(this));
  }

  /**
   * Toggle Row Content
   * @param {event} event 
  */
  toggleContent(event) {
    event.preventDefault();
    const isOpen = this.element.classList.contains('open');
    isOpen ? this.hideContent() : this.showContent();
  }

  /**
   * Show panel content
   */
   showContent() {
    this.toggleBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(this.element, 'open');
    Utility.trapFocus(this.element);

    if(this.element.dataset.behaviour == 'single'){
      let siblingBlocks = this.element.parentNode.querySelectorAll('[is="collapsiblePanel"].open');
      siblingBlocks.forEach(element => {
        if(element == this.element){ return; }
        element.querySelector('.panel_toggle').click();
      });
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.toggleBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(this.element, 'close');
    Utility.removeTrapFocus(this.element);
  }

  static init() {
    const collapsibleElements = document.querySelectorAll('[is="collapsiblePanel"]');
    collapsibleElements.forEach((ele) => {
      new collapsiblePanel(ele);
    });
  }
}
collapsiblePanel.init();
  

  
  